<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <span class="text-muted" style="font-size: 14px">Create By：</span>
        <span class="text-muted" style="font-size: 14px"
          >{{ formData.scoreByName }} at {{ formData.scoreTime }}
        </span>
      </div>
      <div>
        <span class="text-muted" style="font-size: 14px">总分：</span>
        <span style="font-size: 14px">{{ formData.totalTopScore }}</span>
        <el-divider direction="vertical"></el-divider>
        <span class="text-muted" style="font-size: 14px">得分：</span>
        <span style="font-size: 14px">{{ formData.totalScmScore }}</span>
      </div>
    </div>
    <vxe-grid
      class="mt-2"
      border
      round
      resizable
      :tree-config="treeConfig"
      :columns="tableColumn"
      :data="formData.scoreData"
      height="500"
    ></vxe-grid>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formData: {
        scoreTime: "",
        scoreByName: "",
        totalTopScore: "",
        totalScmScore: "",
        scoreData: [],
      },
      treeConfig: {
        children: "listItem",
        expandAll: false,
      },
      tableColumn: [
        { type: "seq", width: 50 },
        {
          field: "itemName",
          title: "评价项目",
          width: 280,
          treeNode: true,
        },
        { field: "itemValue", title: "数值结果", minWidth: 390 },
        {
          field: "topScore",
          title: "满分值",
          width: 80,
          align: "center",
        },
        {
          field: "scmScore",
          title: "实际得分",
          width: 80,
          align: "center",
        },
      ],
    };
  },
  methods: {
    showData(data) {
      this.formData = data;
      // this.treeConfig.expandAll = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.card {
  margin: 20px 10px;
}
</style>
